export const SERVICE_TERMS_VERSION = '2026-10-06';
export const AFFILIATE_TERMS_VERSION = '2026-10-06';
export const REFERRAL_CREDIT_TERMS_VERSION = '2026-10-15';
